import z from 'zod';
import { GeocodedAddressSchema } from '~/lib/model';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';

export enum MlmBrochuresQuantity {
  QTY_25 = '25',
  QTY_50 = '50',
  QTY_100 = '100',
  QTY_250 = '250',
}

export enum MlmBrochureShipping {
  STANDARD = 'standard',
  PICKUP = 'pickup',
  RUSH = 'rush',
}

export enum MlmBrochuresOption {
  TWO = '2',
  FOUR = '4',
  EIGHT = '8',
  TWELVE = '12',
  SIXTEEN = '16',
}

export default createPerformableConfig(
  'brochures',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      option: z.nativeEnum(MlmBrochuresOption),
      quantity: z.nativeEnum(MlmBrochuresQuantity),
      shipping: z.nativeEnum(MlmBrochureShipping).optional(),
      delivery: GeocodedAddressSchema.optional(),
    }),
  },
  {
    name: 'Brochures',
    thumbnail: 'tenant/mpi/brochure/1.jpg',
    short:
      'High quality pront material, professionally designed and printed, poised to impress clients and potential buysers alike. Turn around time varies based off the size of your job. Please contact us if you have any questions before ordering.',
    tenant: TenantId.MAINE_LINE_MEDIA,
    images: [],
    group: 'Print',
  },
);
